import React from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || props.name;
  return <div className="w-full" data-id="element-196">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-slate-300 mb-1.5" data-id="element-197">
          {label}
        </label>}
      <div className="relative" data-id="element-198">
        <select id={selectId} className={`
            block w-full appearance-none rounded-md bg-navy-800 border border-slate-700 
            text-white placeholder-slate-500
            focus:border-teal-500 focus:ring-1 focus:ring-teal-500 focus:outline-none
            disabled:opacity-50 disabled:bg-navy-900
            pl-3 pr-10 py-2 text-sm transition-colors
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}
            ${className}
          `} {...props} data-id="element-199">
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-200">
              {opt.label}
            </option>)}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-slate-400" data-id="element-201">
          <ChevronDown className="h-4 w-4" data-id="element-202" />
        </div>
      </div>
      {error && <p className="mt-1 text-sm text-red-400" data-id="element-203">{error}</p>}
    </div>;
}